module.exports = __webpack_public_path__ + "img/img_brand14.1efabb82.jpg";